export function accordionInit() {
    const items = document.querySelectorAll('.faq-item');

    items.forEach(item => {
        const button = item.querySelector('.faq-question');

        button.addEventListener('click', () => {

            if (item.classList.contains('active')) {
                item.classList.remove('active');
                return;
            }

            items.forEach(el => {
                el.classList.remove('active');
            });

            item.classList.add('active');
        });
    });
}
